import { Field, FieldId, Frequency } from './types';

export const DISPLAY_CONTENT = {
  pageHeader: {
    breadcrumbLabel: 'Project Settings',
    documentationLinkLabel: 'Guidance center',
    headerTitle: 'Global SMS Settings',
    infoBannerText:
      'These recommended settings are not legal advice. It is advised to consult your Legal Counsel to ensure compliance with all applicable laws and industry requirements.',
    learnMoreLabel: 'Learn more',
  },
  contentTable: {
    headerTitle: 'Opt-out instructions',
    headerTitleTooltip:
      "Opt-out instructions are included in SMS campaigns based on the sender ID and the country code in each user's phone number.",
    instructionsTooltipLabel: 'opt-out is not supported in',
    lastModifiedIterableDefaultLabel: 'Iterable Default',
    overflowEditInstructionsLabel: 'Edit instructions',
    overflowVersionHistoryLabel: 'Version history',
    searchFieldPlaceholder: 'Search all available countries',
  },
  editModal: {
    alphanumericFieldHelpText:
      "Alphanumeric Sender IDs use letters and numbers to represent the sender and don't support replies. Opt-out instructions should have a link or contact information to unsubscribe.",
    alphanumericFieldTitle: 'Alphanumeric opt-out text',
    frequencyDisclaimer:
      'To completely disable SMS opt-out instructions for this country, talk to your customer success manager.',
    frequencyDisclaimerNonUSOrCanadaAndDisabled:
      'To change SMS opt-out instructions for this country, talk to your customer success manager.',
    frequencyFieldTitle: 'Frequency',
    frequencyRadioLabelEvery: 'With every SMS campaign',
    frequencyRadioLabelFirst: 'With the first SMS campaign per contact',
    frequencyRadioLabelNever: 'Never',
    frequencyTooltipContent: 'This country requires opt-out text with every SMS campaign.',
    headerAppend: 'opt-out instructions',
    headerCountryFallback: 'Country',
    numericFieldHelpText:
      'Numeric Sender IDs consists of a phone number, such as a long code, short code, or toll-free number. Users can reply to unsubscribe.',
    numericFieldTitle: 'Numeric opt-out text',
    saveButtonLabel: 'Save changes',
    toastSuccessMessageAppend: 'opt-out instructions updated.',
    toastUpdateErrorMessagePrepend: 'Unable to update',
    toastUpdateErrorMessageAppend:
      "'s opt-out instructions. Please try again. If the problem persists, contact your CSM.",
    undoBtnTooltipContent: "Reset to Iterable's default",
    warningBannerText:
      'Any proposed change to this text should be reviewed by your legal counsel to ensure compliance with all applicable law and industry requirements.',
  },
  historyModal: {
    closeButtonLabel: 'Close',
    contentAlphanumericLabel: 'Alphanumeric',
    contentFrequencyLabel: 'Frequency',
    contentNumericLabel: 'Numeric',
    headerAppend: 'version history',
    headerCountryFallback: 'Country',
    iterableLabel: 'Iterable',
    versionCreatePrepend: 'Created by ',
    versionUpdatePrepend: 'Opt-out instructions updated by ',
  },
  missingPermission: {
    headerText: 'You do not have the required permissions to view this page',
    bodyText:
      'To view and change Global SMS Settings, you must have permission to change project settings. Please contact your Iterable administrator.',
  },
};

export const NAVIGATION = {
  projectSettingsPath: '/settings/project',
  documentationPath: 'https://support.iterable.com/hc/en-us/articles/15521924837908',
};

export const FIELDS: Field[] = [
  { fieldName: 'Country', fieldId: FieldId.COUNTRY, sortable: true },
  {
    fieldName: 'Alphanumeric',
    fieldId: FieldId.ALPHANUMERIC,
    sortable: false,
    tooltipContent:
      "Alphanumeric Sender IDs use letters and numbers to represent the sender and don't support replies. Opt-out instructions should have a link or contact information to unsubscribe.",
  },
  {
    fieldName: 'Numeric',
    fieldId: FieldId.NUMERIC,
    sortable: false,
    tooltipContent:
      'Numeric Sender IDs consists of a phone number, such as a long code, short code, or toll-free number. Users can reply to unsubscribe.',
  },
  {
    fieldName: 'Frequency',
    fieldId: FieldId.FREQUENCY,
    sortable: false,
    tooltipContent: 'How often opt-out instructions are sent to a user.',
  },
  { fieldName: 'Last Modified', fieldId: FieldId.UPDATED_AT, sortable: true },
  { fieldName: '', fieldId: FieldId.ACTIONS, sortable: false },
];

export const FREQUENCY_LABELS: { [key in Frequency]: string } = {
  [Frequency.EVERY]: 'Every SMS campaign',
  [Frequency.FIRST]: 'First SMS campaign per contact',
  [Frequency.DISABLED]: 'Never',
};

export const TOAST_ACTIONS = {
  updateSmsPreferences: 'updateSmsPreferences',
};
